





























import { CartItem } from '@/models/cart/cart-item'
import { CartGroup } from '@/models/cart/group/group'
import { CartScope } from '@/models/cart/group/scope'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'
import { totalCountInScope, totalPriceInScope } from '@spa/store/modules/cart/function'

@Component
export default class CartListItem extends Vue {
  @Prop({ required: true })
  group: CartGroup

  get scope(): CartScope {
    return this.group.scope
  }
  get wholeItems(): CartItem[] {
    return this.group.items.list
  }

  get label(): string {
    return this.scope.label.toString()
  }

  get count(): number {
    return totalCountInScope(this.wholeItems)
  }

  get priceLabel(): string {
    return formatPrice(this.totalPrice)
  }

  get linkToCart(): string {
    return `/${this.scope.kind}/${this.scope.value}/cart`
  }

  private get totalPrice(): number {
    return totalPriceInScope(this.wholeItems)
  }
}
